import React from 'react';
import { useConstructorStore } from '../store/constructorStore';
import { t } from '../i18n';

const colorSchemes = [
  { id: 'dark', bg: '#1a1a2e', text: '#ffffff', label: 'color_dark' },
  { id: 'blue', bg: '#0d47a1', text: '#ffffff', label: 'color_blue' },
  { id: 'green', bg: '#1b5e20', text: '#ffffff', label: 'color_green' },
  { id: 'red', bg: '#b71c1c', text: '#ffffff', label: 'color_red' },
  { id: 'purple', bg: '#4a148c', text: '#ffffff', label: 'color_purple' },
  { id: 'light', bg: '#ffffff', text: '#333333', label: 'color_light' },
];

export const Step4Style: React.FC = () => {
  const { bg_color, text_color, language, setField } = useConstructorStore();

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>{t('step4_title', language)}</h2>

      <p style={{ fontSize: 14, color: '#666', marginBottom: 16 }}>{t('color_scheme', language)}</p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
        {colorSchemes.map((scheme) => {
          const isSelected = bg_color === scheme.bg;
          return (
            <button
              key={scheme.id}
              onClick={() => { setField('bg_color', scheme.bg); setField('text_color', scheme.text); }}
              style={{
                height: 60, borderRadius: 12,
                background: scheme.bg, color: scheme.text,
                border: isSelected ? '3px solid #0088cc' : '2px solid #eee',
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
                boxShadow: isSelected ? '0 0 0 2px #0088cc44' : 'none',
              }}
            >
              {t(scheme.label, language)}
            </button>
          );
        })}
      </div>

      {/* Превью */}
      <div style={{ marginTop: 24, padding: 16, borderRadius: 12, border: '1px solid #eee' }}>
        <p style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>Предпросмотр:</p>
        <div style={{
          background: bg_color, color: text_color,
          padding: 20, borderRadius: 8, textAlign: 'center',
        }}>
          <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>Пример заголовка</h3>
          <p style={{ margin: 0, fontSize: 14, opacity: 0.85 }}>Пример описания</p>
        </div>
      </div>
    </div>
  );
};
